import React, { useEffect, useState } from 'react';
import {
  Typography,
  Button,
  TypographyProps,
  Box,
  SxProps,
  ButtonProps,
  Collapse,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { TP_COLORS } from '../../../constants';
import { getAccessLimitState } from '../../../store/AccessLimitSlice';
import { useAppSelector } from '../../../hooks';

const boxStyles: SxProps = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-evenly',
  minHeight: { xs: '84px', sm: '50px' },
  flexDirection: { xs: 'column', sm: 'row' },
  background: {
    xs: `url('${process.env.PUBLIC_URL}/images/landingPage/discount-banner-bg-left.avif') top left/cover no-repeat, ${TP_COLORS.blue.dark}`,
    sm: `url('${process.env.PUBLIC_URL}/images/landingPage/discount-banner-shade-left.avif') top left/contain no-repeat, url('${process.env.PUBLIC_URL}/images/landingPage/discount-banner-bg-left.avif') top left/contain no-repeat, url('${process.env.PUBLIC_URL}/images/landingPage/discount-banner-shade-right.avif') top right/contain no-repeat, url('${process.env.PUBLIC_URL}/images/landingPage/discount-banner-bg-right.avif') top right/contain no-repeat, ${TP_COLORS.gray.darken}`,
  },
};

const typoProps: TypographyProps = {
  variant: 'subtitle1',
  color: TP_COLORS.white,
  textAlign: 'center',
  margin: '8px',
};

const buttonProps: ButtonProps = {
  size: 'small',
  color: 'inherit',
  variant: 'contained',
  sx: {
    color: TP_COLORS.black,
    backgroundColor: TP_COLORS.white,
    fontWeight: '600',
    fontSize: '14px',
    padding: '3px 16px',
    margin: '8px',
  },
};

const DiscountBanner: React.FC = () => {
  const navigate = useNavigate();

  // Store
  const { lpAccess } = useAppSelector(getAccessLimitState);

  // State
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (!lpAccess) {
        setIsVisible(true);
      }
    }, 1000);

    return () => clearTimeout(timer);
  }, [lpAccess]);

  return (
    <Collapse
      in={isVisible}
      timeout={500}
      sx={{
        zIndex: 5,
        position: 'sticky',
        top: { xs: '56px', sm: '64px' },
      }}
    >
      <Box sx={boxStyles}>
        <Typography {...typoProps}>
          Hurry! 🎉 Be among the first 20 to grab 15% off on premium today. Use
          code Disc15 now!
        </Typography>
        <Button
          {...buttonProps}
          onClick={() =>
            navigate(`${process.env.PUBLIC_URL}/dashboard/upgrade`)
          }
        >
          Upgrade Now
        </Button>
      </Box>
    </Collapse>
  );
};

export default DiscountBanner;
